module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friendOrder"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("您成功推荐了"), _c('span', [_vm._v(_vm._s(_vm.total))]), _vm._v("位好友")]), _vm._v(" "), _c('p', {
    staticClass: "content-divide"
  }, [_vm._v("返利明细")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.content.length > 0),
      expression: "content.length > 0"
    }],
    staticClass: "content-inner",
    on: {
      "scroll": _vm.scrollFn
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content-item"
    }, [_c('div', {
      staticClass: "content-item-text"
    }, [_c('span', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('span', {
      staticClass: "money"
    }, [_vm._v("￥" + _vm._s(item.money))])]), _vm._v(" "), _c('div', {
      staticClass: "content-item-text"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("time")(item.created)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "100px",
      "color": "#cccccc"
    }
  }, [_vm._v("暂无数据")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2481bcb7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/friend/friend.vue
// module id = 517
// module chunks = 0